import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const AddSubscriptionUser = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Subscription User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formUserName">
            <Form.Label>User Name</Form.Label>
            <Form.Control type="text" placeholder="Enter user name" />
          </Form.Group>
          <Form.Group controlId="formUserEmail" className="mt-3">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" placeholder="Enter email" />
          </Form.Group>
          <Form.Group controlId="formUserSubscriptionPlan" className="mt-3">
            <Form.Label>Subscription Plan</Form.Label>
            <Form.Control as="select">
              <option>Free Subscription</option>
              <option>Basic Plan</option>
              <option>Premium Plan</option>
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary">
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddSubscriptionUser;
